import LegalPageLayout from "@/components/LegalPageLayout";

const SECTIONS = [
  {
    title: "Vad är cookies?",
    body: [
      "Cookies är små textfiler som sparas på din enhet (dator, surfplatta eller mobiltelefon) när du besöker en webbplats. Cookies används bland annat för att webbplatsen ska fungera korrekt, för att komma ihåg dina inställningar och för att analysera hur webbplatsen används.",
      "På Hundify använder vi cookies för att leverera en bra användarupplevelse, för att förstå hur våra besökare interagerar med webbplatsen och för att kunna förbättra tjänsten över tid.",
    ],
  },
  {
    title: "Vilka cookies använder vi?",
    body: [
      "Vi delar in cookies i tre huvudkategorier:",
      [
        "Nödvändiga cookies — krävs för att webbplatsen och tjänsten ska fungera (till exempel inloggnings­session och språkinställning). Dessa kan inte stängas av.",
        "Funktionella cookies — används för att komma ihåg dina val (till exempel ljust eller mörkt tema) och förbättra användarupplevelsen.",
        "Analys-cookies — hjälper oss att förstå hur besökare interagerar med webbplatsen, vilka sidor som är mest populära och var vi behöver förbättra oss. Datan är aggregerad och anonymiserad.",
      ],
      "Vi använder för närvarande inga marknadsförings- eller tredjeparts­annonscookies på vår publika webbplats.",
    ],
  },
  {
    title: "Tredjepartscookies",
    body: [
      "Vissa av de cookies som används på webbplatsen sätts av tredjepartstjänster, till exempel verktyg för webbanalys eller hosting. Dessa tredjepartsleverantörer har egna integritetspolicyer som du uppmanas att läsa.",
      "Vi väljer noggrant våra underleverantörer och säkerställer att de uppfyller GDPR och annan tillämplig dataskydds­lagstiftning.",
    ],
  },
  {
    title: "Hur länge sparas cookies?",
    body: [
      "Cookies sparas under olika tidsperioder beroende på sitt syfte:",
      [
        "Sessions-cookies raderas automatiskt när du stänger webbläsaren.",
        "Permanenta cookies sparas på din enhet under en bestämd period, vanligtvis mellan några dagar och tolv månader.",
      ],
    ],
  },
  {
    title: "Hantera dina cookie-inställningar",
    body: [
      "Du kan när som helst hantera och radera cookies via din webbläsares inställningar. De flesta webbläsare låter dig blockera cookies helt, blockera tredjepartscookies eller varna dig innan en cookie sparas.",
      "Observera att om du blockerar nödvändiga cookies kan delar av webbplatsen och tjänsten sluta fungera korrekt — till exempel inloggning och sparade inställningar.",
      "Instruktioner för att hantera cookies finns i hjälpsektionen för respektive webbläsare (Chrome, Firefox, Safari, Edge med flera).",
    ],
  },
  {
    title: "Samtycke",
    body: [
      "När du besöker vår webbplats för första gången kan du i vissa fall få en cookie-banner där du kan välja vilka kategorier av cookies du accepterar. Nödvändiga cookies sätts utan samtycke eftersom de krävs för att tjänsten ska fungera, medan övriga cookies endast aktiveras om du gett ditt aktiva samtycke.",
      "Du kan när som helst återkalla ditt samtycke genom att rensa cookies i din webbläsare eller via cookie-bannern.",
    ],
  },
  {
    title: "Mer information",
    body: [
      "För mer information om hur vi behandlar personuppgifter — inklusive uppgifter som samlas in via cookies — hänvisar vi till vår integritetspolicy.",
      "Har du frågor om vår cookieanvändning, kontakta oss via uppgifterna på vår kontaktsida.",
    ],
  },
];

export default function CookiesPage() {
  return (
    <LegalPageLayout
      testid="page-cookies"
      category="Cookies"
      title="Cookiepolicy"
      lastUpdated="December 2026"
      sections={SECTIONS}
      seoDescription="Hundifys cookiepolicy: vilka cookies vi använder, varför, och hur du hanterar dina inställningar. Nödvändiga, funktionella och analys-cookies förklarade."
      seoPath="/cookies"
    />
  );
}
